module.exports = __webpack_public_path__ + "static/media/Solo.71ea3187.jpg";